import { useEffect } from 'react';
import { loadSource } from './actions';
import { loadSourceBlob } from './idb';
import { blobToImageData } from './image-utils';

export function useHydrateSource(): void {
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const blob = await loadSourceBlob();
      if (!blob || cancelled) return;
      const [bytes, imageData] = await Promise.all([blob.arrayBuffer(), blobToImageData(blob)]);
      if (cancelled) return;
      await loadSource({ fileName: 'restored', bytes, imageData });
    })();
    return () => {
      cancelled = true;
    };
  }, []);
}
